// @vendor
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');

const DisclaimerPersonalInfo = () => {
    if(!__CONTACT_CENTER__) return undefined

    return (
        <OKMessage
            type="informative"
        >
            <FormattedText value="disclaimerPersonalInfo-NoAuthorizedOnAccountsMsg" />
                &nbsp;
        </OKMessage>
    );
}

export { DisclaimerPersonalInfo };